import React from 'react'

export const CloseIconSvg = () => {
  return (
    <svg id="svg-close" xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="2 0 25 25">
      <path fill='black' d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
    </svg>
  )
}
